export const HEX_CHARACTERS = '0123456789ABCDEF';
export const NONCE_LENGTH = 16;
export const HTTP = 'http://';
export const HTTPS = 'https://';
export const LOCALHOST = 'localhost';
export const REGEX_DOMAIN =
  /^(\.?(([a-zA-Z\d][a-zA-Z\d-]*[a-zA-Z\d])|[a-zA-Z\d]))(\.(([a-zA-Z\d][a-zA-Z\d-]*[a-zA-Z\d])|[a-zA-Z\d])){1,126}$/;
export const HIDDEN_SECRET_CHAR = '*';
export const SECRET_VISIBLE_LENGTH = 4;
export const VISITOR_VISIT_MAX_LENGTH = 26;
